function getLineChartData(salesSummaryList) {
  // param: salesSummaryList: lista the objetos tipo SalesSummary
  var datasets = [];
  const _companiesNames = [];

  let firstQuarterValues = [];
  let secondQuarterValues = [];
  let thirdQuarterValues = [];
  let fortyQuarterValues = [];

  salesSummaryList.forEach((elem) => {
    _companiesNames.push(elem.company);
    firstQuarterValues.push(elem.quarterSales1);
    secondQuarterValues.push(elem.quarterSales2);
    thirdQuarterValues.push(elem.quarterSales3);
    fortyQuarterValues.push(elem.quarterSales4);
  });

  datasets.push({
    label: "Primer Trimestre",
    color: "info",
    data: firstQuarterValues,
  });

  datasets.push({
    label: "Segundo Trimestre",
    color: "success",
    data: secondQuarterValues,
  });

  datasets.push({
    label: "Tercer Trimestre",
    color: "primary",
    data: thirdQuarterValues,
  });

  datasets.push({
    label: "Cuarto Trimestre",
    color: "warning",
    data: fortyQuarterValues,
  });

  return {
    labels: _companiesNames,
    datasets: datasets,
  };
}

export default getLineChartData;
